require('@fontsource/roboto')
require('@fontsource/noto-sans-jp')

exports.onClientEntry = () => {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return
  const path = window.location.pathname

  // Skip files (e.g., /robots.txt, /sitemap.xml, /assets/*.js)
  if (/\.[a-z0-9]+$/i.test(path)) return

  // Already localized?
  if (/^\/(en|ja)(\/|$)/.test(path)) return

  const userLang = (navigator.language || 'en').slice(0, 2).toLowerCase()
  const locale = ['en', 'ja'].includes(userLang) ? userLang : 'en'

  const newUrl = `/${locale}${path}${window.location.search}${window.location.hash}`
  // Use replace() to avoid an extra entry in history
  window.location.replace(newUrl)
}
